function Mission() {
  return <div>Our work</div>;
}

export default Mission;
